import Component from "vue-class-component";
import * as $ from "jquery";
import { VueBase } from "../Controls/VueBase";
import Calendrier from "../calendrier/calendrier";
import ModalAjouterAbsence from "../gestionDesAbsences/modals/modalAjouterAbsence/modalAjouterAbsence";
import ModalAjoutAbsenceImposeeContrat from "./modalAjoutAbsenceImposeeContrat/modalAjoutAbsenceImposeeContrat";
import ModalSuppressionAbsenceImposeeDate from "./modalSuppressionAbsenceImposeeDate/modalSuppressionAbsenceImposeeDate";
import ModalSuppressionAbsenceImposeeContrat from "./modalSuppressionAbsenceImposeeContrat/modalSuppressionAbsenceImposeeContrat";
import { AbsenceSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import ModalGenerationCRPCEN from "./modalGenerationCRPCEN/modalGenerationCRPCEN";
import { TypeCalendrier } from "../../shared/models/typeCalendrier";
import { ModeOuvertureAbsence } from "../../shared/models/AbsenceEnum";
import ModalAlerteAbsenceCalculeeComponent from "./modalAlerteAbsenceCalculee/modalAlerteAbsenceCalculee";

@Component({
	components: {
		CalendrierComponent: require("../calendrier/calendrier.vue.html"),
		ModalAjouterAbsenceComponent: require("../gestionDesAbsences/modals/modalAjouterAbsence/modalAjouterAbsence.vue.html"),
		ModalAjoutAbsenceImposeeContratComponent: require("./modalAjoutAbsenceImposeeContrat/modalAjoutAbsenceImposeeContrat.vue.html"),
		ModalSuppressionAbsenceImposeeDateComponent: require("./modalSuppressionAbsenceImposeeDate/modalSuppressionAbsenceImposeeDate.vue.html"),
		ModalSuppressionAbsenceImposeeContratComponent: require("./modalSuppressionAbsenceImposeeContrat/modalSuppressionAbsenceImposeeContrat.vue.html"),
		ModalGenerationAttestationComponent: require("./modalGenerationCRPCEN/modalGenerationCRPCEN.vue.html"),
		ModalAlerteAbsenceCalculeeComponent: require("./modalAlerteAbsenceCalculee/modalAlerteAbsenceCalculee.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as PlanningAbsencesComponent);
			if (to.query.filtre != undefined) {
				vm.calendrier.init(to.query.filtre as string);
			} else {
				vm.calendrier.init();
			}
		});
	},
	beforeRouteUpdate(to, from, next) {
		const _this = (this as PlanningAbsencesComponent);

		if (to.query.filtre != undefined) {
			_this.calendrier.init(to.query.filtre as string);
		} else {
			_this.calendrier.init();
		}
		next();
	}
})
export default class PlanningAbsencesComponent extends VueBase {
	public isModified = false;
	public calendrier: Calendrier = new Calendrier();
	public dataReady = true;
	public typeCalendrierPlanningDesAbsences = TypeCalendrier.GestionDesAbsences;

	public mounted(): void {
		this.calendrier = this.$refs.calendrierComponent as Calendrier;
	}

	public enregistrerAbsenceOk(absence: AbsenceSalarieDto): void {
		this.calendrier = this.$refs.calendrierComponent as Calendrier;
		this.calendrier.fetchData();
	}

	public enregistrementAbsenceCollectiveOk(nouvelleAbsence: AbsenceSalarieDto): void {
		$("#modalAjoutAbsenceImposeeDate").modal("hide");

		const ModalAjoutAbsenceImposeeContrat = this.$refs.modalAjoutAbsenceImposeeContrat as ModalAjoutAbsenceImposeeContrat;

		if (ModalAjoutAbsenceImposeeContrat != undefined) {
			ModalAjoutAbsenceImposeeContrat.init(nouvelleAbsence);
		}

		$("#modalAjoutAbsenceImposeeContrat").modal({
			backdrop: "static"
		});
	}

	public enregistrementAbsenceImposeeOk(): void {
		$("#modalAjouterAbsence").modal("hide");
		this.calendrier = this.$refs.calendrierComponent as Calendrier;
		this.calendrier.fetchData();
	}

	public enregistrementSuppressionAbsenceImposeeDateOk(selectedAbsence: AbsenceSalarieDto): void {
		$("#modalSuppressionAbsenceImposeeDate").modal("hide");

		const ModalSuppressionAbsenceImposeeContrat = this.$refs.modalSuppressionAbsenceImposeeContrat as ModalSuppressionAbsenceImposeeContrat;

		if (ModalSuppressionAbsenceImposeeContrat != undefined) {
			ModalSuppressionAbsenceImposeeContrat.init(selectedAbsence);
		}

		$("#modalSuppressionAbsenceImposeeContrat").modal({
			backdrop: "static"
		});
	}

	public enregistrementSuppressionAbsenceImposeeOk(): void {
		this.calendrier = this.$refs.calendrierComponent as Calendrier;
		this.calendrier.fetchData();
	}

	public onDeleteAbsence(): void {
		$("#modalChangerEtatAbsence").modal({
			backdrop: "static" //, keyboard: false
		});
	}

	public generationCRPCEN(data: AbsenceSalarieDto): void {
		const modalGenerationCRPCEN = this.$refs.modalGenerationCRPCEN as ModalGenerationCRPCEN;
		if (modalGenerationCRPCEN != undefined) {
			modalGenerationCRPCEN.init(data);
		}

		$("#modalGenerationCRPCEN").modal({
			backdrop: "static"
		});
	}

	public onAddAbsence(employeId: number, idConge?: number, dateMoisOuverture?: Date): void {
		const modalAjouterAbsence = this.$refs.modalAjouterAbsence as ModalAjouterAbsence;

		if (modalAjouterAbsence != undefined) {
			modalAjouterAbsence.init(ModeOuvertureAbsence.AbsenceSalarieParGestionnaire, dateMoisOuverture, employeId, idConge);
		}

		$("#modalAjouterAbsence").modal({
			backdrop: "static" //, keyboard: false
		});
	}

	public onAddAbsenceImposee(dateMoisOuverture?: Date): void {
		const modalAjouterAbsence = this.$refs.modalAjouterAbsence as ModalAjouterAbsence;

		if (modalAjouterAbsence != undefined) {
			modalAjouterAbsence.init(ModeOuvertureAbsence.AbsenceCollectiveParGestionnaire, dateMoisOuverture);
		}

		$("#modalAjouterAbsence").modal({
			backdrop: "static" //, keyboard: false
		});
	}

	public onDeleteAbsenceImposee(): void {
		const modalSuppressionAbsenceImposeeDate = this.$refs.modalSuppressionAbsenceImposeeDate as ModalSuppressionAbsenceImposeeDate;

		if (modalSuppressionAbsenceImposeeDate != undefined) {
			modalSuppressionAbsenceImposeeDate.init();
		}

		$("#modalSuppressionAbsenceImposeeDate").modal({
			backdrop: "static"
		});
	}

	public ouvrirPopupAlerteAnnulation(absence: AbsenceSalarieDto): void {
		const modalAlerteAbsenceCalculee = this.$refs.modalAlerteAbsenceCalculee as ModalAlerteAbsenceCalculeeComponent;

		if (modalAlerteAbsenceCalculee != undefined) {
			modalAlerteAbsenceCalculee.init(absence);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/planningAbsences/planningAbsences.ts